// extracted by mini-css-extract-plugin
export default {"root":"checkbox_root__-e8-O","checkbox":"checkbox_checkbox__Ll5bi","label":"checkbox_label__kJn9+","disabled":"checkbox_disabled__UO8k7"};